// import { WEBSERVER } from './Webserver.js';
// import { PORT } from './Port.js';
import { API } from './API.js';

import axios from 'axios';

// const url = WEBSERVER + ':3000/api/countries/'
const url = API + '/countries/'
const debug = false;

class Countries {
    // get countries
    static get() {
        return new Promise ( async (resolve, reject) => {
            try {
                const res = await axios.get(url);
                const data = res.data;
                resolve(
                    data.map(country=> ({
                        ...country,
                        name: country.name
                    }))
                );
                if (debug) console.log("Countries.get: data = ", data)
            } catch(err) {
                reject(err);
            }

        })
    }

    // get one country
    static getone(id) {
        return axios.get(`${url}${id}`)
            .then(response => {
                console.log('Countries.getone: ',response.data)
                return response.data
            })
            .catch(error => {
                console.log('Countries.getone: ',error)
            })
    }

    // create country
    static create(postdata) {
        return axios.post(url, postdata)
            .then(response => {
                console.log('countries.create: ',response)
                return response.data._id
            })
            .catch(error => {
                console.log('countries.create: ',error)
            })
    }

    static update(id,postdata) {
        console.log('Countries.update: id=',id)
        console.log('Countries.update: postdata=',postdata)
        return axios.put(`${url}${id}`, postdata)
            .then(response => {
                console.log('Countries.update: ',response)
                return id
            })
            .catch(error => {
                console.log('Countries.update: ',error)
            })
    }

    // delete country
    static delete(id) {
        return axios.delete(`${url}${id}`)
    }
}

export default Countries